/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchItineraries200ResponseResultsInner } from './SearchItineraries200ResponseResultsInner';
import {
    SearchItineraries200ResponseResultsInnerFromJSON,
    SearchItineraries200ResponseResultsInnerFromJSONTyped,
    SearchItineraries200ResponseResultsInnerToJSON,
    SearchItineraries200ResponseResultsInnerToJSONTyped,
} from './SearchItineraries200ResponseResultsInner';

/**
 * 
 * @export
 * @interface SearchItineraries200Response
 */
export interface SearchItineraries200Response {
    /**
     * 
     * @type {Array<SearchItineraries200ResponseResultsInner>}
     * @memberof SearchItineraries200Response
     */
    results?: Array<SearchItineraries200ResponseResultsInner>;
    /**
     * Total number of matches
     * @type {number}
     * @memberof SearchItineraries200Response
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof SearchItineraries200Response
     */
    page?: number;
    /**
     * Results per page
     * @type {number}
     * @memberof SearchItineraries200Response
     */
    limit?: number;
    /**
     * Search query executed
     * @type {string}
     * @memberof SearchItineraries200Response
     */
    query?: string;
    /**
     * Search duration in milliseconds
     * @type {number}
     * @memberof SearchItineraries200Response
     */
    duration?: number;
}

/**
 * Check if a given object implements the SearchItineraries200Response interface.
 */
export function instanceOfSearchItineraries200Response(value: object): value is SearchItineraries200Response {
    return true;
}

export function SearchItineraries200ResponseFromJSON(json: any): SearchItineraries200Response {
    return SearchItineraries200ResponseFromJSONTyped(json, false);
}

export function SearchItineraries200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchItineraries200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SearchItineraries200ResponseResultsInnerFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'query': json['query'] == null ? undefined : json['query'],
        'duration': json['duration'] == null ? undefined : json['duration'],
    };
}

  export function SearchItineraries200ResponseToJSON(json: any): SearchItineraries200Response {
      return SearchItineraries200ResponseToJSONTyped(json, false);
  }

  export function SearchItineraries200ResponseToJSONTyped(value?: SearchItineraries200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(SearchItineraries200ResponseResultsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'query': value['query'],
        'duration': value['duration'],
    };
}

